/*
  eslint
  no-prototype-builtins: off,
  react/no-array-index-key: off
*/

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import { remove as removeSystemMessage }
  from '../../../store/messages/systemMessages/actions';
import { retrieveDetails } from '../../../store/messages/systemMessages/lib';
import styles from './styles.scss';

function SystemMessage(props) {
  const {
    type, iClass, expandable, index,
    remove, toggleExpanded, args,
  } = props;

  const {
    body, action, icon, showClear,
  } = retrieveDetails({ type, args });

  let parsedBody = body;
  if (typeof body === 'string') {
    parsedBody = <p>{body}</p>;
  }

  // if !expandable and !first message,
  const notExpandable =
    !expandable && index <= 0 ? 'notExpandable' : '';

  return (
    <div
      className={`${styles.systemmessage} ${type}`}
      onClick={action}
    >
      <i className={icon} />
      {parsedBody}
      {showClear ?
        <button
          className={styles[notExpandable]}
          onClick={(e) => {
            e.stopPropagation();
            remove(index);
          }}
        >
          <i className="fa fa-close" />
        </button>
        : null}
      {expandable ?
        <button className="toggle-button" onClick={toggleExpanded}>
          <i className={`fa fa-chevron-up ${iClass}`} />
        </button> : null}
    </div>
  );
}


SystemMessage.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  body: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  index: PropTypes.number,
  remove: PropTypes.func,
  expandable: PropTypes.bool,
  toggleExpanded: PropTypes.func,
  iClass: PropTypes.string,
  args: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
    PropTypes.number,
  ]),
};

class SystemMessages extends React.Component {
  static getHeight(num) {
    // height w/ padding * 1 rem + border top and bottom
    return (3.6 * 16 + 2) * num; // eslint-disable-line
  }

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      iClass: '',
      bounds: {
        top: 0,
        bottom: 0,
      },
      position: {
        y: 0,
        x: 0,
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    const newBounds = {
      bottom: 0,
      top: -SystemMessages.getHeight(nextProps.messages.length - 1),
    };
    this.setState({
      bounds: newBounds,
    });
    // handle a 'mouse release'
    this.handleMouseRelease(null, { y: this.state.position.y }, newBounds.top);
  }

  /**
   * Makes the notification bar expand or contract
   */
  toggleExpanded() {
    const expanded = this.state.iClass !== '';
    const newI = !expanded ? 'fa-rotate-180' : '';
    const nextState = { expanded: !expanded, iClass: newI, position: { x: 0 } };
    if (expanded) {
      nextState.position.y = 0;
    } else {
      // not expanded -> expand
      nextState.position.y = this.state.bounds.top;
    }
    this.setState(nextState);
  }

  handleMouseRelease(e, data, maxTop = this.state.bounds.top) {
    const currentY = data.y;

    if (e === null) { // coming from a props update - make sure we're in the right range
      if (currentY === 0) {
        return null; // just leave it;
      }

      if (maxTop === SystemMessages.getHeight(1)) {
        return this.setState({
          position: {
            y: -SystemMessages.getHeight(1),
            x: 0,
          },
        });
      }
    }

    if (currentY < maxTop || typeof currentY !== 'number') {
      return this.setState({
        position: {
          y: maxTop,
          x: 0,
        },
      });
    }
    return this.setState({
      position: {
        y: currentY,
        x: 0,
      },
    });
  }

  handleDragStart(_, d) {
    if (d.y < -5) {
      this.setState({ expanded: true, iClass: 'fa-rotate-180' });
    } else {
      this.setState({ expanded: false, iClass: '' });
    }
  }

  render() {
    let title = '';

    if (this.props.messages.length === 0) {
      return null;
    }
    const numMessages = this.props.messages.length;
    if (numMessages === 1 || this.state.expanded === true) {
      title = this.props.messages[0].body;
    } else {
      title = `${this.props.messages[0].body} + ${numMessages - 1} more`;
    }

    const first = this.props.messages[0];
    const firstMessage = (
      <SystemMessage
        expandable={numMessages > 1}
        toggleExpanded={() => this.toggleExpanded()}
        iClass={this.state.iClass}
        body={title}
        type={first.type}
        args={first.args}
        action={first.action}
        icon={first.icon}
        key={0}
        index={0}
        remove={this.props.removeSystemMessage}
        showClear={first.hasOwnProperty('showClear') ? first.showClear : true}
      />
    );


    const remainingMessages = this.props.messages.slice(1);

    return (
      <Draggable
        axis='y'
        bounds={{ ...this.state.bounds, left: 0, right: 0 }}
        position={this.state.position}
        onDrag={(e, d) => this.handleDragStart(e, d)}
        onStop={(e, data) => this.handleMouseRelease(e, data)}
      >
        <div
          style={{ top: this.state.styleTop }}
          className={styles.systemmessages}
        >
          {firstMessage}
          {remainingMessages.map((message, i) =>
            (<SystemMessage
              {...message}
              showClear={message.hasOwnProperty('showClear') ? message.showClear : true}
              key={i + 1}
              index={i + 1}
              remove={this.props.removeSystemMessage}
            />))}
        </div>
      </Draggable>
    );
  }
}

SystemMessages.propTypes = {
  messages: PropTypes.array,
  removeSystemMessage: PropTypes.func,
};

export default connect(null, { removeSystemMessage })(SystemMessages);



// WEBPACK FOOTER //
// ./src/components/shared/systemmessage/main.jsx